import styled from '@emotion/styled'

export const StyleInputWrapper = styled.div<any>`
  position: relative;
`
export const StyleInput = styled.input<any>`
  width: 100%;
  border-radius: 6px;
  height: 40px;
  text-indent: ${(props) =>
    props?.hasIcon && props?.side == 'left' ? '35px' : '10px'};
  padding: 0px;
  border: 1px solid
    ${(props) =>
      props?.hasError
        ? props.theme.colors.danger
        : !!props?.isFocus
          ? props.theme.colors.primary
          : props.theme.colors.inputBorder};
  outline: none;
  font-size: 14px;
  &::placeholder {
    font-size: 12px;
    color: ${(props) => props.theme.colors.placeholder};
    font-family: Lato;
    font-weight: 300;
  }
  background-color: ${(props) =>
    props.theme.colors[props?.disabled ? 'white' : 'white']};
  cursor: ${(props) => (props?.disabled ? 'not-allowed' : 'pointer')};

  ${(props) => props.hasIcon && props?.side == 'right' && `padding-left: 35px;`}
  ${(props) => props.styleInput}
`

export const StyleIconWrapper = styled.div<any>`
  position: absolute;
  height: 100%;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    display: block;
  }
  ${(props) => {
    if (props.side == 'right') {
      return `right: 0px;`
    } else {
      return `left: 0px;`
    }
  }}
`

export const StyleDropDownOptionWrapper = styled.div<any>`
  width: 100%;
  background: ${(props) => props.theme.colors.white};
  box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.1);
  position: absolute;
  z-index: 1111;
  top: ${(props) => props.top}px;
`
export const StyleDropDownOptionItems = styled.ul<any>`
  width: 100%;
  background: ${(props) => props.theme.colors.white};
  max-height: 150px;
  min-height: 100px;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  ::-webkit-scrollbar {
    display: none;
  }
`
export const StyleDropDownOption = styled.li<any>`
  padding: 7px 10px;
  font-size: 12px;
  background: ${(props) =>
    props.isActive ? props.theme.colors.primary : props.theme.colors.white};
  color: ${(props) =>
    props.isActive ? props.theme.colors.white : props.theme.colors.black};
  &:hover {
    background: ${(props) => props.theme.colors.primary};
    color: ${(props) => props.theme.colors.white};
  }
`

export const StyleNotData = styled.p<any>`
  font-size: 12px;
  text-align: center;
  padding: 10px 0px;
`
